import { render, staticRenderFns } from "./GuideCard.vue?vue&type=template&id=32e7e2fd&scoped=true&"
import script from "./GuideCard.vue?vue&type=script&lang=js&"
export * from "./GuideCard.vue?vue&type=script&lang=js&"
import style0 from "./GuideCard.vue?vue&type=style&index=0&id=32e7e2fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e7e2fd",
  null
  
)

export default component.exports